/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Invite_SubmitInputs */

const cs_portal_invite_submit = /** @type {(inputs: Portal_Invite_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivovat účet`)
};

const en_portal_invite_submit = /** @type {(inputs: Portal_Invite_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activate account`)
};

/**
* | output |
* | --- |
* | "Activate account" |
*
* @param {Portal_Invite_SubmitInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portal_invite_submit = /** @type {((inputs?: Portal_Invite_SubmitInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Invite_SubmitInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portal_invite_submit(inputs)
	return cs_portal_invite_submit(inputs)
});